import { useState, useCallback } from 'react';
import { DeviceType, MarsusInfo, SednaInfo } from './Device';
import log from 'app/home/general-components/Logging';

import { ReactComponent as IconScenario1White } from 'images/scenario/scenario-1-white.svg';
import { ReactComponent as IconScenario1 } from 'images/scenario/scenario-1.svg';
import { ReactComponent as IconScenario2White } from 'images/scenario/scenario-2-white.svg';
import { ReactComponent as IconScenario2 } from 'images/scenario/scenario-2.svg';
import { ReactComponent as IconScenario3White } from 'images/scenario/scenario-3-white.svg';
import { ReactComponent as IconScenario3 } from 'images/scenario/scenario-3.svg';
import { ReactComponent as IconScenario4White } from 'images/scenario/scenario-4-white.svg';
import { ReactComponent as IconScenario4 } from 'images/scenario/scenario-4.svg';
import { ReactComponent as IconScenario5White } from 'images/scenario/scenario-5-white.svg';
import { ReactComponent as IconScenario5 } from 'images/scenario/scenario-5.svg';
import { ReactComponent as IconScenario6White } from 'images/scenario/scenario-6-white.svg';
import { ReactComponent as IconScenario6 } from 'images/scenario/scenario-6.svg';
import { ReactComponent as IconScenario7White } from 'images/scenario/scenario-7-white.svg';
import { ReactComponent as IconScenario7 } from 'images/scenario/scenario-7.svg';
import { ReactComponent as IconScenario8White } from 'images/scenario/scenario-8-white.svg';
import { ReactComponent as IconScenario8 } from 'images/scenario/scenario-8.svg';
import { ReactComponent as IconScenario9White } from 'images/scenario/scenario-9-white.svg';
import { ReactComponent as IconScenario9 } from 'images/scenario/scenario-9.svg';

export const scenarioIcons = [
    [IconScenario1, IconScenario1White, "#FF5A85"],
    [IconScenario2, IconScenario2White, "#23D4FF"],
    [IconScenario3, IconScenario3White, "#FF6200"],
    [IconScenario4, IconScenario4White, "#BFA9FF"],
    [IconScenario5, IconScenario5White, "#FF4F4F"],
    [IconScenario6, IconScenario6White, "#00FFDC"],
    [IconScenario7, IconScenario7White, "#BFA9FF"],
    [IconScenario8, IconScenario8White, "#FFC900"],
    [IconScenario9, IconScenario9White, "#BFA9FF"],
]

export function getScenarioIcon(picId, whiteIcon=false, canReturnUndefined=false) {
    let iconIndex = whiteIcon ? 1 : 0;
    if (picId <= 9) {
        return scenarioIcons[picId - 1][iconIndex]
    } else {
        if (canReturnUndefined) {
            return undefined;
        }
        return scenarioIcons[0][iconIndex];
    }
}

export function checkAndTransformDeviceForScenario(negotiatedProtocol, device) {
    switch (device.type) {
        case DeviceType.siren:
        case DeviceType.lamp:
        case DeviceType.lampX1TwoWay:
        case DeviceType.plug:
        case DeviceType.dpst:
        case DeviceType.relay4:
            return device;
        case DeviceType.evaporativeCooler:
            return (negotiatedProtocol.hasEvaporativeCoolerInBindAndScenario ? device : null);
        case DeviceType.wc:
            return (negotiatedProtocol.hasWCInBindAndScenario ? device : null);
        case DeviceType.marsus:
            switch (device.sub_type) {
                case MarsusInfo.subType.fanCoil:
                    return device;
                case MarsusInfo.subType.package:
                case MarsusInfo.subType.cooler:
                default:
                    return null;
            }
        case DeviceType.lampX3:
            return (negotiatedProtocol.hasLampX3InBindAndScenario ? device : null);
        case DeviceType.lampX4:
            return (negotiatedProtocol.hasLampX4InScenario ? device : null);
        case DeviceType.curtain1Lamp2:
            return (negotiatedProtocol.hasCurtain1Lamp2 ? device : null);
        case DeviceType.curtain:
            return (negotiatedProtocol.hasCurtain ? device : null);
        case DeviceType.hinavaEcoThermostat:
            return (negotiatedProtocol.hasEcoThermostat ? device : null);
        case DeviceType.sedna:
            switch (device.sub_type) {
                case SednaInfo.subType.volkan:
                    return device;
                default:
                    return null;
            }
        case DeviceType.remote:
        case DeviceType.tuyaRemote:
            let _device = { ...device };
            _device.sub_devices = _device.sub_devices.filter(d => checkAndTransformDeviceForScenario(negotiatedProtocol, d))
            return (negotiatedProtocol.hasRemoteInBindAndScenario) && (device.sub_devices.length > 0) ? _device : null;
        case DeviceType.tvRemote:
            return (negotiatedProtocol.hasRemoteInBindAndScenario) ? device : null;
        case DeviceType.elevator1:
            return (negotiatedProtocol.hasElevator1InBindAndScenario) ? device : null;
        case DeviceType.doorbell:
            return (negotiatedProtocol.hasDoorbellInBindAndScenario) ? device : null;
        case DeviceType.splitRemote:
            if (device.config_per_mode)
                return (negotiatedProtocol.hasRemoteInBindAndScenario) ? device : null;
            else
                return null;
        default:
            return null;
    }
}

export default function useScenarioList(sendEvent) {
    const [scenarios, setScenarios] = useState([])

    const onScenarioRelatedEvent = useCallback((message) => {
        switch (message.ev) {
            case 'scenario_list':
                let newScenarios = message.msg.scenarios.map((scenario) => {
                    return {
                        ...scenario,
                        run: (() => {
                            sendEvent('run_scenario', {
                                id: scenario.id,
                            });
                        }),
                        remove: (() => {
                            sendEvent('remove_scenario', {
                                id: scenario.id,
                            });
                        }),
                    };
                })
                setScenarios(newScenarios);
                break;
            case 'edit_scenario':
                let newScenarios2 = scenarios.map((scenario) => {
                    if (scenario.id !== message.msg.id)
                        return scenario;

                    const finalScenario = {
                        ...message.msg,
                        run: (() => {
                            sendEvent('run_scenario', {
                                id: message.msg.id,
                            });
                        }),
                        remove: (() => {
                            sendEvent('remove_scenario', {
                                id: message.msg.id,
                            });
                        }),
                     };
                    return finalScenario;
                })
                setScenarios(newScenarios2);
                break;
            default:
                log('unsupported event in onScenarioRelatedEvent,', message.ev);
                break;
        }
    }, [sendEvent, scenarios])

    const createNewScenario = useCallback((scenario) => {
        sendEvent('new_scenario', scenario);
    }, [sendEvent]);

    const editScenario = useCallback((scenario) => {
        sendEvent('edit_scenario', scenario);
    }, [sendEvent]);

    return [scenarios, onScenarioRelatedEvent, createNewScenario, editScenario];
}
